module.exports = __webpack_public_path__ + "static/media/business_3.47bdca78.png";